import { Avatar, Box, Button, Flex, Image, Text, Switch } from "@chakra-ui/react";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconCheckRed from "../../assets/images/iconCheckRed.png";
import iconRejected from "../../assets/images/contract/x-circle.svg";
import { RiResetLeftFill } from "react-icons/ri";
import { ParticipantList } from "../../components/table/participantList";

const openTransactionDetailModal = ({ id, status, submit }) => {
  window.dispatchEvent(
    new CustomEvent("OPEN_TRANSACTION_DETAIL_MODAL", {
      detail: {
        id,
        type: "LOCKING",
        status,
        submit,
      },
    })
  );
};

export const formatTableValue = (
  value,
  key,
  submit,
  id,
  revert,
  syncIsWrongInput
) => {
  switch (key) {
    case "startTime": {
      const timestamp = value;
      const date = new Date(timestamp);

      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return <Text>{formattedDate}</Text>;
    }

    case "contact": {
      const infos = value?.split("-") || [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {infos?.length &&
            infos?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    }

    case "rate":
      return <Text>{value}%</Text>;

    case "bankInfo": {
      const bankInfo = value?.split("-") || [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {bankInfo?.length &&
            bankInfo?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    }

    case "identificationNumberInfo": {
      const identificationNumberInfo = value?.split("-") || [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {identificationNumberInfo?.length &&
            identificationNumberInfo?.map((item, index) => (
              <Text key={index}>{item}</Text>
            ))}
        </Flex>
      );
    }

    case "avatar":
      return <Avatar src={value} />;

    case "statusTtkq":
      return (
        <Flex
          w={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={1}
        >
          {value && <Image src={iconApproved} w={"20px"} />}
        </Flex>
      );

    case "statusTtkqSalesContract":
      return (
        <Flex
          w={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={1}
        >
          {value && <Image src={iconApproved} w={"20px"} />}
        </Flex>
      );

    case "inputLate":
      return (
        <Flex
          w={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={1}
        >
          {value && <Image src={iconCheckRed} w={"16px"} height={"16px"} />}
        </Flex>
      );

    case "isWrongInput":
      return (
        <Flex
          w={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
        >
          <Switch
            isChecked={!!value}
            colorScheme="blue"
            onChange={(e) => syncIsWrongInput?.(e.target.checked, id)}
          />
        </Flex>
      );

    case "statusSalesContract":
      return (
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          gap={1}
          w={"100%"}
        >
          {value && <Image src={iconApproved} w={"20px"} />}
        </Flex>
      );

    case "status": {
      let content;

      if (value === "NEW" || value === "EDITING") {
        content = (
          <>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() =>
                openTransactionDetailModal({
                  id,
                  status: "APPROVED",
                  submit,
                })
              }
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Duyệt
            </Button>

            <Button
              bg={"var(--color-main)"}
              color={"var(--color-option-employee-hover)"}
              border={"1px solid var(--color-option-employee-hover)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit("REJECTED", id)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Ko duyệt
            </Button>
          </>
        );
      } else if (value === "APPROVED") {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconApproved} w={"20px"} />
              <Text color={"var(--color-status-employ)"}>Đã được duyệt</Text>
            </Flex>

            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => revert("APPROVED", id)}
              h={"28px"}
              minH={"28px"}
            >
              <RiResetLeftFill size={"18px"} />
            </Button>
          </Flex>
        );
      } else if (value === "REFUND") {
        content = (
          <>
            <Image src={iconApproved} />
            <Text
              color={"var(--color-status-employ)"}
              w={"max-content"}
              minW={"max-content"}
              display={"block"}
            >
              Đã hoàn trả
            </Text>
          </>
        );
      } else {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconRejected} w={"20px"} />
              <Text color={"var(--text-red-employee)"}>
                Không được phê duyệt
              </Text>
            </Flex>

            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => revert("REJECTED", id)}
              h={"28px"}
              minH={"28px"}
            >
              <RiResetLeftFill size={"18px"} />
            </Button>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"max-content"}>
          {content}
        </Flex>
      );
    }

    case "reviewer":
      return (
        <Box textAlign={"end"}>
          <Text
            fontSize={"14px"}
            lineHeight={"19.6px"}
            fontWeight={"500"}
            color={"var(--color-info-employee)"}
          >
            {value.name}
          </Text>

          <Text
            fontSize={"12px"}
            lineHeight={"16.8px"}
            fontWeight={"400"}
            color={"var(--color-label-employee)"}
          >
            {value.jobTitle}
          </Text>
        </Box>
      );

    case "employee":
      return (
        <Text
          cursor={"pointer"}
          color={"var(--color-option-employee-hover)"}
          onClick={() => submit(id)}
          textDecoration={"underline"}
        >
          {value}
        </Text>
      );

    case "participants":
      return <ParticipantList value={value} />;

    default:
      return <Text>{value}</Text>;
  }
};